import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ListChecks, BarChart3, UserPlus } from "lucide-react";
import { getCompanyName } from "../Components/HR/Services/CompanyServices";

const ALL_TABS = [
    { key: "preview", label: "Preview Questions", icon: ListChecks },
    { key: "analytics", label: "Preview Analytics", icon: BarChart3 },
    { key: "assign", label: "Manage Users", icon: UserPlus, adminOnly: true },
];

const ROUTES = {
    preview: (assessmentUID) => `/Company/dashboard/my-assessments/preview/${assessmentUID}`,
    analytics: (assessmentUID) => `/Company/dashboard/my-assessments/analytics/${assessmentUID}`,
    assign: (assessmentUID) => `/Company/dashboard/my-assessments/assign-users/${assessmentUID}`,
};

const HRAssessmentNavTabs = ({ active, assessmentUID, assessmentName, description }) => {
    const navigate = useNavigate();
    const [isAdmin, setIsAdmin] = useState(false);

    useEffect(() => {
        const fetchRole = async () => {
            try {
                const res = await getCompanyName();
                if (res?.data?.roleID === 5 && res?.data?.roleName === "Company Admin") {
                    setIsAdmin(true);
                }
            } catch (err) {
            }
        };
        fetchRole();
    }, []);

    const TABS = ALL_TABS.filter(tab => !tab.adminOnly || isAdmin);

    const goTo = (key) => {
        if (key === active) return;
        const state = { assessmentUID, assessmentName, description };
        navigate(ROUTES[key](assessmentUID), { state });
    };

    return (
        <div className="w-full rounded-2xl border border-gray-100 bg-white shadow-[0_4px_24px_rgba(15,23,42,0.05)] mb-6">
            <div className="flex h-16 items-center px-8">
                {TABS.map(({ key, label, icon: Icon }) => {
                    const isActive = active === key;
                    const isDisabled = !assessmentUID;

                    return (
                        <button
                            key={key}
                            type="button"
                            onClick={() => goTo(key)}
                            disabled={isDisabled}
                            className={`relative flex h-full items-center gap-2 px-6 text-[15px] font-medium transition-colors ${isActive
                                ? "text-[#7f35b2] after:absolute after:bottom-0 after:left-0 after:h-[3px] after:w-full after:rounded-full after:bg-[#7f35b2]"
                                : "text-gray-500 hover:text-gray-700"
                                } ${isDisabled ? "cursor-not-allowed opacity-40" : ""}`}
                        >
                            <Icon size={15} />
                            {label}
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default HRAssessmentNavTabs;

